import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';

@Component({})
export default class BurguerMenu extends Vue {

  @Prop({ default: false }) show;

  @Getter getOpenBurguerMenu;

  @Mutation OPEN_BURGUER_MENU;

  mounted() {

  }

  _onRoute(toName: string) {
    const currentRoute = this.$route;
    if(toName !== currentRoute.name) {
      this.$router.replace({ name: toName });
    } else {
      this.$router.go(0);
    }
    this.OPEN_BURGUER_MENU(false);
  }

  _toggleBurguerMenu() {
    this.OPEN_BURGUER_MENU(!this.getOpenBurguerMenu);
  }
}